import { memo } from 'react';

import { useAlgoTileId } from '@/App/tiles/orders/AlgoOrders/AlgoContext.tsx';
import { OrderSpot } from '@/App/tiles/orders/components/OrderSpot.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectSpotAlgoData } from '@/store/orders/algoOrders/selectors.ts';

export const ConnectedAlgoOrderSpot = memo(() => {
  const tileId = useAlgoTileId();
  const spotDate = useAppSelector((state) => selectSpotAlgoData(state, tileId));

  return <OrderSpot spotDate={spotDate} />;
});
